/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Progress_StartingInputs */



/**
* | output |
* | --- |
* | "starting..." |
*
* @param {New_Project_Media_Progress_StartingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_progress_starting = /** @type {((inputs?: New_Project_Media_Progress_StartingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Progress_StartingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("demarrage...")
	if (locale === "de") return /** @type {LocalizedString} */ ("beginnend...")
	if (locale === "it") return /** @type {LocalizedString} */ ("di partenza...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("начало...")
	if (locale === "es") return /** @type {LocalizedString} */ ("a partir de...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("起動...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("começando...")
	return /** @type {LocalizedString} */ ("starting...")
});